var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKitchen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.725 5.75V2.8H5.225V5.75H3.725ZM3.725 14.775V9.875H5.225V14.775H3.725ZM1.5 20C1.0875 20 0.734375 19.8531 0.440625 19.5594C0.146875 19.2656 0 18.9125 0 18.5V1.5C0 1.0875 0.146875 0.734375 0.440625 0.440625C0.734375 0.146875 1.0875 0 1.5 0H14.5C14.9125 0 15.2656 0.146875 15.5594 0.440625C15.8531 0.734375 16 1.0875 16 1.5V18.5C16 18.9125 15.8531 19.2656 15.5594 19.5594C15.2656 19.8531 14.9125 20 14.5 20H1.5ZM1.5 18.5H14.5V8.55H1.5V18.5ZM1.5 7.05H14.5V1.5H1.5V7.05Z",
    fill: "#E1E1E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitchen);
export default __webpack_public_path__ + "static/media/kitchen.68684bea6da978dfeed4ce149264f9b8.svg";
export { ForwardRef as ReactComponent };